import React from "react";
import styled from "styled-components";

const CTASection = ({ title, description, buttonText, buttonLink }) => {
  return (
    <Container aria-labelledby="cta-title" aria-describedby="cta-description">
      <h2 id="cta-title">{title}</h2>
      <p id="cta-description">{description}</p>
      <CTAButton href={buttonLink}>{buttonText}</CTAButton>
    </Container>
  );
};

const Container = styled.div`
  background-color: var(--hhb-primary);
  color: #fff;
  text-align: center;
  padding: 40px 20px;
  border-radius: 5px;
  margin: 40px 0;
`;

const CTAButton = styled.a`
  display: inline-block;
  background-color: #fff;
  color: var(--hhb-primary);
  padding: 15px 30px;
  text-decoration: none;
  border-radius: 5px;
  font-size: 1.2em;
  font-weight: bold;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: var(--hhb-darkblue);
    color: #fff;
  }
`;

export default CTASection;
